import React from "react";
import {BreadcrumbsItem} from "react-breadcrumbs-dynamic";

export interface BreadcrumbItemProps {
  to: string;
  text: string;
}

class BreadcrumbItem extends React.PureComponent<BreadcrumbItemProps> {

  render() {
    return (
      <BreadcrumbsItem to={this.props.to}>
        {this.props.text}
      </BreadcrumbsItem>
    );
  }
}

export default BreadcrumbItem;
